import { TSendMessagePayload } from '@/models/chat.model';
import { isMobile } from "@/utils";

type TMessage = {
  userId: string;
  message: string;
  phone?: string
  isNew: boolean;
  messageId: string,
};

export const sendMessageMapper = ({
  isNew,
  message,
  userId,
  messageId,
  phone
}: TMessage): TSendMessagePayload => ({
  is_new: isNew,
  message,
  userId,
  phone,
  isMobile: isMobile() ? ("True" as const) : ("False" as const),
  messageId,
  messageSource: 'WIDGET'
});
